import { Injectable } from '@angular/core';
import { Observable, Subscriber, Subscription } from 'rxjs';
import { ApiService } from '../base/api.service';
import { ApiEndpointsService } from '../base/api-endpoints.service';
import { ServerResponse } from '../../interfaces/base/server.response';
import { Report } from '../../interfaces/report/report';
import { HeadCategory } from '../../interfaces/routering/head-category';

@Injectable()

export class ReportService {

  constructor(private api: ApiService,
              private apiEndpoints: ApiEndpointsService,
  ) {
  }

  index(formData: any): Observable<Report[]> {
    return new Observable<Report[]>((o: Subscriber<Report[]>) => {
      const subscription: Subscription = this.api.post(this.apiEndpoints.get('reports'), formData)
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<Report[]>response.data);
          } else {
            o.next(null);
          }
        }, (): void => o.next(null));

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  categories(): Observable<HeadCategory[]> {
    return new Observable<HeadCategory[]>((o: Subscriber<HeadCategory[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('categories'))
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<HeadCategory[]>response.data);
          } else {
            o.next(null);
          }
        }, (): void => o.next(null));

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }
}
